import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";

import {EntityViewPanel} from "base/entity";
import {SectionCard, SectionField} from "base/component/presentational";
import {CoordinationindexesService} from "./CoordinationindexesService";

export const CoordinationindexesViewPanel = () => {
    const {id} = useParams();

    const [entityState, setEntityState] = useState(null);

    useEffect(() => {
        CoordinationindexesService.get(id).then(data => {
            setEntityState(data);
        });
    }, [id]);

    return (
        entityState && (
            <EntityViewPanel title="Coordination Indexes" showDetailButton={false}>
                <SectionCard title={`${entityState.id}`}>
                    <SectionField label="Country:" value={entityState.country} />
                    <SectionField label="CI:" value={entityState.ci_txt} />
                    <SectionField
                        label="CI Horizontal:"
                        value={entityState.ci_hor_txt}
                    />

                    <SectionField label="CI Vertical:" value={entityState.ci_ver_txt} />

                    <SectionField label="CI Spatial:" value={entityState.ci_spa_txt} />

                    <SectionField
                        label="CI Resources:"
                        value={entityState.ci_res_txt}
                    />

                    <SectionField
                        label="CI Communication:"
                        value={entityState.ci_com_txt}
                    />
                </SectionCard>
            </EntityViewPanel>
        )
    );
};
